module.exports = __webpack_public_path__ + "static/media/ic-gg.3e38dc7d.svg";